/**
 * Unified GEL currency formatting
 * Standard: "1 234 ₾" — space-grouped thousands, symbol after, no decimals
 */

export const formatGEL = (amount: number, compact = false): string => {
  const rounded = Math.round(amount);
  if (compact && rounded >= 10000) {
    return `${(rounded / 1000).toFixed(1).replace(/\.0$/, '')}K ₾`;
  }
  const formatted = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${formatted} ₾`;
};

/** For chart axes / tooltips — shorter, no thousands grouping */
export const formatGELShort = (value: number): string => `${Math.round(value)} ₾`;
